module.exports = __webpack_public_path__ + "img/3.a55e59da.jpg";